/**
 * ブランド選択ボタンの状態に応じて「もっと見る」ボタンのリンク先を動的に更新するスクリプト
 * 
 * 機能:
 * - hb-js-brandSelectBtnの子要素のうち、add-activeが付与されている要素のブランド名を取得
 * - 取得したブランド名を使用してhb-js-moreBtnのリンク先を更新
 * 
 * 仕様:
 * - NEW ITEMのリンク形式: collections/新商品?filter.p.vendor=[ブランド名]&sort_by=created-descending
 * - ランキングのリンク形式: collections/ranking?filter.p.vendor=[ブランド名]&sort_by=best-selling
 * - 複数のブランドが選択されている場合は、すべてのブランドをフィルターに含める
 * - ページ読み込み時とブランド選択要素にadd-activeが付与されたときに自動的に更新される
 * - 複数のブランド選択ボタングループが存在する場合にも対応
 */

// グローバル初期化フラグ
if (typeof window.hbTopMoreBtnInitialized === 'undefined') {
  window.hbTopMoreBtnInitialized = false;

  // もっと見るボタンのリンク先を更新する関数
  function updateMoreButtonLinks(collectionElement) {
    // 更新対象のコレクション要素が指定されていない場合は処理しない
    if (!collectionElement) return;
    
    // このコレクション内のブランド選択ボタンを取得
    const brandSelector = collectionElement.querySelector('.hb-js-brandSelectBtn');
    // このコレクション内のもっと見るボタンを取得
    const moreButton = collectionElement.querySelector('.hb-js-moreBtn');
    
    if (!brandSelector || !moreButton) return;
    
    // セクションの種類を判定（タイトル要素の内容を使用）
    const titleElement = collectionElement.querySelector('.hb-top-head_ttlMain');
    const sectionTitle = titleElement ? titleElement.textContent.trim() : '';
    const isRanking = sectionTitle === 'RANKING';
    
    // 選択されたブランド名を集める
    const selectedBrands = [];
    
    // このセレクタ内のアクティブアイテムを処理
    const activeItems = brandSelector.querySelectorAll('li.add-active');
    
    activeItems.forEach(function(item) {
      const ttl = item.querySelector('.hb-brand_itemTtl');
      if (ttl) {
        const brandName = ttl.textContent.trim();
        if (brandName && !selectedBrands.includes(brandName)) {
          selectedBrands.push(brandName);
        }
      }
    });
    
    // もっと見るボタンのリンク先を更新
    let url;
    
    // セクションの種類に応じてベースURLを設定
    if (isRanking) {
      url = 'collections/ranking';
    } else {
      url = 'collections/新商品';
    }
    
    // クエリパラメータの構築
    let queryParams = [];
    
    // ブランドフィルターの追加（ランキング・NEW ITEM共にvendorパラメータを使用）
    if (selectedBrands.length > 0) {
      selectedBrands.forEach(function(brand) {
        // ランキング・NEW ITEM共に vendor パラメータを使用
        queryParams.push(`filter.p.vendor=${encodeURIComponent(brand)}`);
      });
    }
    
    // 新着商品の場合は商品タイプフィルターを追加
    if (!isRanking) {
      queryParams.push(`filter.p.product_type=${encodeURIComponent('新商品')}`);
    }
    
    // ソートパラメータの追加（ランキングかどうかで異なる値を使用）
    if (isRanking) {
      queryParams.push('sort_by=best-selling');
    } else {
      queryParams.push('sort_by=created-descending');
    }
    
    // クエリパラメータをURLに追加
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }
    
    moreButton.setAttribute('href', url);
  }

  // ブランドボタンクリック時の処理
  function setupBrandButtonEvents() {
    // すべてのブランドボタンを対象にする
    const brandButtons = document.querySelectorAll('.hb-js-brandSelectBtn li');
    
    brandButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        // クリックされたボタンが所属するコレクション要素を特定
        const parentCollection = this.closest('.hb-collection');
        if (!parentCollection) return;
        
        // このコレクション内のブランドセレクタを取得
        const brandSelector = parentCollection.querySelector('.hb-js-brandSelectBtn');
        if (!brandSelector) return;
        
        // このセレクタ内のすべてのアクティブ要素からadd-activeを削除
        brandSelector.querySelectorAll('li.add-active').forEach(item => {
          item.classList.remove('add-active');
        });
        
        // このボタンを選択状態にする
        this.classList.add('add-active');
        
        // 少し遅延させてURLを更新（このコレクション要素のみ）
        setTimeout(function() {
          updateMoreButtonLinks(parentCollection);
        }, 100);
      });
    });
  }

  // ページロード時の初期化処理
  document.addEventListener('DOMContentLoaded', function() {
    // 二重初期化防止
    if (window.hbTopMoreBtnInitialized) return;
    
    // ボタンのイベントリスナーを設定
    setupBrandButtonEvents();
    
    // 初期状態ですべてのコレクションのURLを設定
    const collections = document.querySelectorAll('.hb-collection');
    collections.forEach(function(collection) {
      updateMoreButtonLinks(collection);
    });
    
    // 初期化完了をマーク
    window.hbTopMoreBtnInitialized = true;
  });
}
